module.exports = __webpack_public_path__ + "img/yanjinAppImage.e237f5f5.png";